module.exports = __webpack_public_path__ + "static/Supportiv-dcf971fada1d44c3a3350ecbc6f52874.jpg";